export function norm2digit(numb: number = 0): string {
  return numb.toLocaleString('en-US', { minimumIntegerDigits: 2 });
}
